export const data = [
    {
      imagelink: "https://i.ibb.co/6Pm1J01/medal.png",
      award: "1st Position Spyder, Web Dev Event",
      details:
        "Created a cutting-edge crime alert system that empowers users to share vital information regarding incidents occurring in their vicinity.",
      issuer: "Issued by Ureckon, UEM Kolkata · Apr 2022"  
    },
    {
      imagelink: "https://i.ibb.co/NxsGgqD/medal-2.png",
      award: "2nd Position Spyder, Web Dev Event",
      details:
        "Tasked with creating a web product, based on the provided UI design.",
      issuer: "Issued by Ureckon, UEM Kolkata · Feb 2023"  
    },
    {
      imagelink: "https://i.ibb.co/HTKnc3m/gold-medal-1.png",
      award: "4th Position Ureckathon, Hackathon",
      details:
        "Created an innovative online EdTech web-based platform designed to facilitate classroom development, resource sharing, and quiz administration.",
      issuer: "Issued by Ureckon, UEM Kolkata · Feb 2023"  
    },
    {
      imagelink: "https://i.ibb.co/s6znbP3/medal-3.png",
      award: "3rd Position Department of CSE, 2020-21",
      details:
        "Achieved 3rd place in the Department of Computer Science and Engineering for the academic year 2020-21.",
      issuer: "Issued by UEM, Kolkata · Aug 2021"  
    },
    {
      imagelink: "https://i.ibb.co/HTKnc3m/gold-medal-1.png",
      award: "Winner of Devfest Quiz 2021",
      details:
        " ",
      issuer: "Issued by Devfest, Google Developer Groups · Oct 2021"  
    },
    
  ];
